export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

export async function apiRequest(path, options = {}, session = null) {
  const headers = { 'Content-Type': 'application/json', ...options.headers };
  if (session?.access_token) {
    headers['Authorization'] = `Bearer ${session.access_token}`;
  }
  const res = await fetch(`${API_BASE}${path}`, { ...options, headers });
  return res.json();
}
